import { css } from '@emotion/react';
import { SpacingToken, DesignToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  margin-top: var(${SpacingToken.Spacing7});
  padding: 0 var(${SpacingToken.Spacing5});
  width: 100%;

  ${MEDIA_MIN_SM} {
    margin-top: 90px;
  }
`;

export const headerContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  padding-bottom: var(${SpacingToken.Spacing7});
`;

export const heading = css`
  display: flex;
`;

export const contextEventSubHeading = css`
  margin-top: var(${SpacingToken.Spacing5});
  max-width: 400px;
  display: inline-block;
`;

export const description = css`
  margin: var(${SpacingToken.Spacing3}) 0;
`;

export const signInWrapper = css`
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
`;

export const formWrapper = css`
  margin: var(${SpacingToken.Spacing7}) 0 var(${SpacingToken.Spacing10}) 0;
`;

export const formField = css`
  width: 100%;
`;

export const formHiddenField = css`
  display: none;
`;

export const disabledField = (disabled: boolean) => css`
  > input {
    ${disabled &&
    `
      cursor: not-allowed;
      color: var(${DesignToken.ContentBasicDisabled});
    `}
  }
`;

export const logInButton = css`
  width: 100%;
`;

export const headerEmailRecognized = css`
  margin-bottom: var(${SpacingToken.Spacing6});
`;

export const customSSO = css`
  margin-top: var(${SpacingToken.Spacing3});
  margin-bottom: var(${SpacingToken.Spacing6});
`;

export const mfaButton = css`
  width: 100%;
`;
